module.exports = __webpack_public_path__ + "static/20-mrsilla-9433d5acdcd54f605778a941f2b675e0.jpg";